import {
    Box,
    Checkbox,
    FormControlLabel,
    InputAdornment,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import { COLORS } from "../../../../ui/Theme";
import {
    useDerivativesCommodityMarketContext
} from "../../../../context/derivatives/commodity-market/DerivativesCommodityMarketContext";
import { useSearchParams } from "react-router-dom";
import useResponsive from "../../../../components/hooks/useResponsive";
import { CgArrowsExchangeAltV } from "react-icons/cg";

const DerivativesCommodityMarketFutureContractsForm = () => {
    const { positions, isSaffronChecked, setIsSaffronChecked } = useDerivativesCommodityMarketContext();

    const { isSm } = useResponsive();
    const [searchParams, setSearchParams] = useSearchParams();
    const params = new URLSearchParams(searchParams);
    const currentPosition = searchParams.get("position" || "long");

    const handlePosition = (e) => {
        params.set("position", e.target.value);
        setSearchParams(params);
    };


    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    width: { xs: "100%", md: "auto" },
                }}
            >
                {isSm && (
                    <Typography sx={{ fontSize: "12px", color: COLORS.GRAY }}>
                        پوزیشن
                    </Typography>
                )}

                <Select
                    value={currentPosition}
                    onChange={handlePosition}
                    sx={{
                        width: { xs: "100%", sm: "50%", md: "120px" },
                    }}
                    startAdornment={
                        !isSm && (
                            <InputAdornment position="start">
                                <CgArrowsExchangeAltV
                                    size={"24px"}
                                    sx={{ fontSize: "24px", color: COLORS.GRAY }}
                                />
                            </InputAdornment>
                        )
                    }
                >
                    {positions.map((position) => (
                        <MenuItem key={position.id} value={position.id}>
                            {position.name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>

            <Box
                sx={{
                    bgcolor: COLORS.INPUTBG,
                    p: "8px 10px",
                    borderRadius: "12px",
                    width: { xs: "100%", md: "auto" },
                    display: "flex",
                }}
            >
                <FormControlLabel
                    sx={{
                        m: 0,
                    }}
                    control={
                        <Checkbox
                            checked={isSaffronChecked}
                            sx={{ fontSize: "14px", p: 0 }}
                            onChange={(e) => setIsSaffronChecked(e.target.checked)}
                        />
                    }
                    label="نمایش قراردادهای زعفران"
                />
            </Box>
        </Box>
    );
};

export default DerivativesCommodityMarketFutureContractsForm;
